import { Center, Loader } from "@mantine/core";

export function ReportPhotoLoading() {
  return (
    <Center py="lg">
      <Loader size="sm" />
    </Center>
  );
}
